"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var datapoints_1 = require("../datapoints");
var createDropViewState_1 = require("owa-dnd/lib/utils/createDropViewState");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
var isInFavorites_1 = require("../selectors/isInFavorites");
/**
 * Add a favorite category from the favorite store
 * @param id of the category
 * @param actionSource where the remove favorite category comes from
 */
exports.default = legacy_1.action('addFavoriteCategory', datapoints_1.default.AddFavoriteCategory)(function addFavoriteCategory(id, actionSource) {
    // Check if category is already in favorites
    if (isInFavorites_1.isCategoryInFavorites(id)) {
        // This function should not be called when duplicate category is added to favorites
        throw new Error('Cannot add duplicate category to favorites.');
    }
    // Add favorite category to favorite store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.push(id);
    owa_mail_favorites_store_1.favoritesStore.favoriteCategories.set(id, {
        id: id,
        type: 5 /* Category */,
        treeType: 'favorites',
        dropViewState: createDropViewState_1.default(),
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=addFavoriteCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/addFavoriteCategory.js
// module id = 3336
// module chunks = 14 68